import Call from './Call';
import TransitionButton from './TransitionButton';
import Layout from './Layout';
import { ColorPalettes } from '../../../../../patient/src/features/reservation/constants/ColorPalettes';
import { ClinicProps } from '../types/Props';

function Top({ clinicName }: ClinicProps) {
  return (
    <Layout flowName="受付トップ" clinicName={clinicName || undefined}>
      <p className="text-2xl sm:text-3xl font-bold text-gray-500 my-14 text-center">ご来院ありがとうございます</p>
      <TransitionButton title="QRコードを読み取る" flow="QRcodeReader" />
      <TransitionButton
        title="当日予約の方はこちら"
        flow="LINEFriendAdd"
        sx={{
          bgcolor: ColorPalettes.WHITE,
          color: ColorPalettes.MAIN,
          border: '1px solid',
          borderColor: ColorPalettes.MAIN,
          mt: '32px'
        }}
      />
      {/* 呼び出しは要件により一旦非表示 */}
      {/* <Call className="mt-10" /> */}
    </Layout>
  );
}

export default Top;
